import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Box, Button } from '@mui/material'
import Translations from 'src/@core/layouts/components/Translations'
import GradientBox from 'src/views/reports/gradient-box'
import { rdYwGn } from 'src/@core/utils/gradients'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { useRouter } from 'next/router'

interface Props {
  percentage: number
  landId: number
}

export default function CardDp5({ percentage, landId }: Props) {
  const router = useRouter()

  return (
    <Card
      className='dp5-card'
      sx={{
        minWidth: '250px',
        height: '260px',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          minWidth: '250px',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: '700', color: 'black', textAlign: 'center' }}
            className='cards-title'
          >
            <Translations text={'Productive capacity'} />
          </Typography>
          <Box
            className='steps-del-campo'
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '145px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <GradientBox colors={rdYwGn} tall='15px' />
              <Box sx={{ width: '90%' }}>
                <ArrowDropUpIcon
                  sx={{ verticalAlign: 'middle', color: 'black', marginLeft: `${percentage * 90}%` }}
                  fontSize='large'
                />
              </Box>
            </Box>
            <Typography sx={{ fontSize: '40px', fontWeight: 700, color: 'black' }}>{`${(percentage * 100).toFixed(
              0
            )} %`}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', w: '100%', alignItems: 'center', mt: 'auto' }}>
            <Button
              variant='outlined'
              sx={{
                color: '#213D36',
                width: 'auto',
                padding: '8px, 12px, 8px, 12px',
                fontSize: '16px',
                fontWeight: 700,
                borderRadius: '30px',
                border: '3px solid #213D36',
                mt: 'auto'
              }}
              onClick={() => router.push(`/models/${landId}`)}
            >
              <Translations text={'See report'} />
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
